module.exports = __webpack_public_path__ + "img/defaule-shop-logo.bbf51795.png";